import { useState } from "react";
import { Alert } from "reactstrap";
import ExcelCSVInput from "../Inputs/ExcelCSVInput";

// headers - The expected headers the CSV file should could contain, returns columns of these headers onChange.
const CSVImporter = ({ headers, onSuccess }) => {
  const [error, setError] = useState();

  const onFileDataChange = (data) => {
    const csvHeaders = data[0];

    if (data.length < 1 || csvHeaders?.length < 1) {
      return setError("Invalid CSV File");
    }

    const headerPositions = {};

    for (const header of headers) {
      const headerIndex = csvHeaders.indexOf(header);

      if (headerIndex < 0) {
        return setError(
          `CSV File must contain headers of ${headers} (Case sensitive)`
        );
      }

      headerPositions[header] = headerIndex;
    }

    const filteredData = [];

    for (let i = 1; i < data.length; i++) {
      const dataArr = data[i];
      const newItem = {};

      for (const header of headers) {
        newItem[header] = dataArr[headerPositions[header]];
      }

      filteredData.push(newItem);
    }

    onSuccess(filteredData);
  };

  const handleInvalidFileError = () => {
    setError("Invalid File");
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <ExcelCSVInput
          onDataChange={onFileDataChange}
          onError={handleInvalidFileError}
          onClear={true}
          autoDelete={true}
        />
      </div>
      {error && (
        <Alert color="warning" className="mt-2 p-2 w-100 text-center">
          {error}
        </Alert>
      )}
    </>
  );
};

export default CSVImporter;
